import defaultStyles from "fond/draw/defaultStyles";
import { NBN_SOURCE, NBN_SOURCE_LAYER, NBN_SOURCE_LAYER_FILTER, NBN_STYLE_ID } from "fond/draw/modes/nbn/constants";
import { MapboxStyleLayer } from "fond/types";

const baseSymbolStyle = {
  layout: {
    "text-field": ["case", ["==", ["get", "user_excluded"], "true"], "\uE85D", "\uE85C"],
    "text-anchor": "bottom",
    "text-justify": "center",
    // Note we prevent overlap and ignore placement to ensure only one icon is shown per feature location,
    // however take note that icons not rendered due to overlap are not returned in mapbox queryRenderedFeatures calls.
    "text-allow-overlap": false,
    "text-ignore-placement": false,
    "text-font": ["fontello Regular"],
    "text-padding": 0,
    "text-rotate": 0.01,
    "text-size": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 16],
    "text-line-height": -0.45,
  },
  paint: {
    "text-color": ["case", ["==", ["get", "user_excluded"], "true"], "red", "green"],
    "text-opacity": ["case", ["boolean", ["feature-state", "isEditing"], false], 0, 1],
    "text-translate": [-0.6, 0.1],
    "text-halo-width": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 2],
    "text-halo-color": "#ffffff",
  },
} as Pick<mapboxgl.SymbolLayer, "layout" | "paint">;

/**
 * The MapboxDraw theme extended to include styles specific to planner projects
 * when drawing address features.
 */
const modifiedDefaults: MapboxStyleLayer[] = defaultStyles.map((style) => {
  if (style.id === "gl-draw-point-stroke-active") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-radius": 12,
        "circle-color": "#FFF000",
      },
    } as mapboxgl.CircleLayer;
  }

  if (style.id === "gl-draw-point-point-stroke-inactive") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-radius": 0,
      },
    } as mapboxgl.CircleLayer;
  }

  if (["gl-draw-point-active", "gl-draw-point-inactive"].includes(style.id)) {
    return {
      ...style,
      type: "symbol",
      layout: {
        ...baseSymbolStyle.layout,
      },
      paint: {
        ...baseSymbolStyle.paint,
      },
    } as mapboxgl.SymbolLayer;
  }

  return style;
});

const styles: MapboxStyleLayer[] = [
  {
    id: NBN_STYLE_ID,
    type: "symbol",
    source: NBN_SOURCE,
    "source-layer": NBN_SOURCE_LAYER,
    filter: NBN_SOURCE_LAYER_FILTER,
    ...baseSymbolStyle,
  } as mapboxgl.SymbolLayer,
  ...modifiedDefaults,
];

export default styles;
